import React from 'react'
import Header from '../Components/Header'
import Banner from '../Components/Banner'
import OurCountries from '../Components/OurCountries'
import Footer from '../Components/Footer'

const Home = () => {
  return (
   <>
   <Header/>
   <Banner/>
   <OurCountries/>
   <Footer/>
   </>
  )
}

export default Home